/**
 * 2026-10-23 (the e-sign cleanup PR; the reschedule marker, Matt's turn-on list): a visit moved to where no new
 * paperwork link can go, so the portal cancelled the old link. The needs-attention row says why and what to do.
 * The reason is "portal_block_esign_moved_" + the step's stop word (services/esign_trigger.BLOCK_MOVED_PREFIX).
 */
export const MOVED_PREFIX = "portal_block_esign_moved_";

export const MOVED_COPY = {
  portal_block_esign_moved_visit_too_soon:
    "Paperwork link cancelled — the visit moved to less than 2 hours away, too soon for a new link. Use paper for this visit",
  portal_block_esign_moved_visit_too_far:
    "Paperwork link cancelled — the visit moved more than 4 months out. Use paper, or send a new link closer to the visit",
  portal_block_esign_moved_out_of_state:
    "Paperwork link cancelled — the visit moved to a clinic outside California. Use that clinic's paper forms",
  portal_block_esign_moved_location_not_listed:
    "Paperwork link cancelled — the visit moved to a clinic that isn't on e-sign yet. Use paper for this visit",
  portal_block_esign_moved_no_visit_time:
    "Paperwork link cancelled — the new visit has no time on it. Use paper for this visit",
};

const FALLBACK = "Paperwork link cancelled — the visit moved where no new link can go. Use paper for this visit";

/** The row's wording for a moved-visit marker, or "" when the reason is not one. */
export function movedCopy(reason) {
  const r = String(reason || "");
  if (!r.startsWith(MOVED_PREFIX)) return "";
  return MOVED_COPY[r] || FALLBACK;
}
